import axios from "axios";

const API_URL = `${process.env.REACT_APP_NODE_API}/job-application`;

export const careerAppService = (token, application) => {
  console.log("application det : ", { ...application });
  return axios.post(
    API_URL,
    { ...application },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
